import {
  deliveryIdFromMission,
  findPoolEntry,
  isReplayEntry,
  REPLAY_PASS_COST,
  type GiantId,
  type PlayerEconomyState,
} from '../../../domain';
import { useAppStore } from '../../store/appStore';
import {
  createNewDeliveryScreenModel,
  type NewDeliveryScreenProps,
} from './NewDeliveryScreenModelScreen';
import { NewDeliveryScreenController } from './NewDeliveryScreenController';
import { NewDeliveryScreenView } from './NewDeliveryScreenView';

export type { NewDeliveryScreenProps } from './NewDeliveryScreenModelScreen';

function deliveryNeedsReplayPass(
  playerEconomy: PlayerEconomyState,
  giantId: GiantId,
  orderIndex: number,
): boolean {
  const deliveryId = deliveryIdFromMission({ giantId, orderIndex });
  const poolEntry = findPoolEntry(playerEconomy, deliveryId);
  if (poolEntry != null) {
    return isReplayEntry(poolEntry);
  }
  // History-only entries are restored as replays on take.
  return (playerEconomy.deliveryHistory ?? []).some(
    (entry) => entry.deliveryId === deliveryId,
  );
}

export function NewDeliveryScreen(props: NewDeliveryScreenProps) {
  const passesBalance = useAppStore((s) => s.passesBalance);
  const playerEconomy = useAppStore((s) => s.playerEconomy);
  const orderIndex = props.orderIndex ?? 0;
  const needsReplayPass = deliveryNeedsReplayPass(
    playerEconomy,
    props.giantId,
    orderIndex,
  );
  const canTakeOrder =
    props.canTakeOrder !== false &&
    (!needsReplayPass || passesBalance >= REPLAY_PASS_COST);

  const model = createNewDeliveryScreenModel({ ...props, canTakeOrder });
  const controller = new NewDeliveryScreenController(model);

  return <NewDeliveryScreenView model={model} controller={controller} />;
}
